module.exports = __webpack_public_path__ + "img/3.2bd2d12c.jpg";